import { createAction, createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { ITitleText } from "InterfacesTypes/interfaces";


export interface ITitleTextState {
    titleTexts: ITitleText[];
    loading: boolean;
    error: string | null;
}

const initialState: ITitleTextState = {
    titleTexts: [],
    loading: false,
    error: null,
}

export const fetchTitleTexts = createAction("titleText/titleText");


export const titleTextSlice = createSlice({
    name: "titleText",
    initialState,
    reducers: {
        fetchStart(state) {
            state.loading = true;
            state.error = null;
        },
        fetchSuccess(state, action: PayloadAction<ITitleText[]>) {
            state.loading = false;
            state.titleTexts = action.payload;
        },
        fetchFailure(state, action: PayloadAction<string | null | undefined>) {
            state.loading = false;
            state.error = action.payload ?? "Något gick fel";
        },
        setTitleTexts(state, action: PayloadAction<ITitleText[]>) {
            state.titleTexts = action.payload;
        },
    },
});

export const { fetchStart, fetchSuccess, fetchFailure, setTitleTexts } = 
    titleTextSlice.actions;

export const TitleTextsReducer = titleTextSlice.reducer;